import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Alert } from '../../design/alert/S_Alert';
import { ColumnLayout } from '../../modules/common/layouts/columnLayout/ColumnLayout';
import { InputStatus } from '../models/error.model';

interface IProps {
  id?: string;
  errors: InputStatus;
  useDefaultMessageWhenCodeNotFound?: boolean;
}

export const FormAlert = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  if (!props.errors.errorCodes.length) {
    return <></>;
  }
  const errorMessages = props.errors.errorCodes.map((errorMessage, i) => {
    let translatedMessage = t(errorMessage);

    const codeNotFound = errorMessage === translatedMessage;
    if (props.useDefaultMessageWhenCodeNotFound && codeNotFound) {
      translatedMessage = t('something_went_wrong');
    }

    return (
      <div
        id={props.id}
        key={i}
      >
        {translatedMessage}
      </div>
    );
  });

  return (
    <S_Alert color='danger'>
      <ColumnLayout size='sm'>{errorMessages}</ColumnLayout>
    </S_Alert>
  );
});
